import { ArrowBack } from "@material-ui/icons";
import { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import client from "../../api/client";
import { GetSingleArtikel } from "../../graphql/news/queries";
import { convertMillisToDDMMYYYY } from "../../lib/utils/formatDate";

const Article = () => {
  const { id } = useParams();
  const [news, setNews] = useState(null);
  const navigation = useHistory();

  useEffect(() => {
    if (!id) return;

    client
      .query({
        query: GetSingleArtikel,
        variables: {
          id: id,
        },
      })
      .then((val) => {
        console.log(val);
        const { ListArtikel: data, response } = val.data.GetSingleArtikel;
        if (response.status !== "0") {
          throw new Error(response.errMsg);
        } else if (data.length !== 0) {
          setNews(data[0]);
        } else {
          navigation.replace("/news");
        }
      })
      .catch(() => {
        navigation.replace("/news");
      });
  }, [id, navigation]);

  return (
    <section className="news">
      <div className="news__news-content">
        <div className="news__title">{news?.judulArtikel}</div>
        <p
          style={{
            fontSize: "1.4rem",            
            marginTop: "-23px",
            marginBottom: "2.5rem",
          }}
        >
          Posted date, {convertMillisToDDMMYYYY(news?.createDate)}.
        </p>{" "}
        <br />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <img src={news?.fotoArtikel} alt="" className="news__karatop" />
        </div>
        <div>
          <div
            className="news__text"
            dangerouslySetInnerHTML={{
              __html: news?.isiArtikel,
            }}
          ></div>
          <div
            className="news__back"
            onClick={() => {
              navigation.push("/news/");
            }}
          >
            <ArrowBack
              style={{
                marginRight: "1rem",
              }}
            />
            Kembali
          </div>
        </div>
      </div>
    </section>
  );
};

export default Article;
